import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import RedefiningModernHair from "./sections/RedefiningModernHair";
import TheSignatureLookbook from "./sections/TheSignatureLookbook";
import ArtistryTechniques from "./sections/ArtistryTechniques";
import TheVelvetExperience from "./sections/TheVelvetExperience";
import ClientLove from "./sections/ClientLove";
import InvestmentExtensionGuide from "./sections/InvestmentExtensionGuide";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <RedefiningModernHair />
      <TheSignatureLookbook />
      <ArtistryTechniques />
      <TheVelvetExperience />
      <ClientLove />
      <InvestmentExtensionGuide />
      <Footer />
    </div>;
}